import React from "react";
import PageBanner from "../components/PageBanner";
import "./Reviews.css";

const Reviews = () => {
  return (
    <div className="reviews-page">
      <PageBanner title="Reviews" />

      <section className="section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Client reviews</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              Thank you to everyone who shares feedback—we read every review and
              use it to keep improving.
            </p>
          </div>

          <div className="reviews-content">
            <p>
              More reviews and a live Google connection can be added here when
              you&apos;re ready.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Reviews;
